<template>
  <div>
    <Card style="padding-bottom: 40px">
      <Form :model="EmergencyWorkSituationForm">
        <FormItem label="时间">
          <DatePicker type="daterange" v-model="EmergencyWorkSituationForm.signTime" placeholder="选择日期"
                      @on-change="getEmergencyWorkSituationList" clearable @on-clear="clearData"></DatePicker>
        </FormItem>
      </Form>
      <Table ref="EmergencyWorkSituationRefs" :loading="EmergencyWorkSituationLoading"
             :data="EmergencyWorkSituationList"
             :columns="EmergencyWorkSituationColumns"></Table>
      <Button type="primary" style="float: left;margin-top: 10px" @click="exportReportAndDispose">导出附件
      </Button>
    </Card>
  </div>
</template>
<script>
import table2excel from 'js-table2excel'

export default {
  data() {
    return {
      EmergencyWorkSituationLoading: false,
      EmergencyWorkSituationList: [],
      EmergencyWorkSituationColumns: [
        {title: '单位', key: 'dept', align: 'center'},
        {title: '地点', key: 'address', align: 'center'},
        {title: '时间', key: 'reportTime', align: 'center'},
        {title: '事件描述', key: 'eventDescription', align: 'center'},
        {
          title: '现场图片',
          align: 'center',
          children: [
            {
              title: '处置前',
              align: 'center',
              render: (h, params) => {
                return h('div', [
                  h('el-image', {
                    props: {
                      src: params.row.frontImage === null ? '' : JSON.parse(JSON.parse(JSON.stringify(params.row.frontImage))).url
                    },
                    style: {
                      width: '100px',
                      height: '100px'
                    }
                  })
                ])
              }
            },
            {
              title: '处置后',
              align: 'center',
              render: (h, params) => {
                return h('div', [
                  h('el-image', {
                    props: {
                      src: params.row.afterImage === null ? '' : JSON.parse(JSON.parse(JSON.stringify(params.row.afterImage))).url,
                    },
                    style: {
                      width: '100px',
                      height: '100px'
                    }
                  })
                ])
              }
            },
          ]
        },
        {title: '处置意见', key: 'disposalOpinions', align: 'center'},
        {title: '事件状态', key: 'eventStatus', align: 'center'},
      ],
      EmergencyWorkSituationForm: {
        signTime: []
      }
    }
  },
  mounted() {
    this.EmergencyWorkSituationForm.signTime = [this.$moment().subtract(20, 'weeks').format('YYYY-MM-DD'), this.$moment().format('YYYY-MM-DD')]
    this.getEmergencyWorkSituationList()
  },
  methods: {
    exportReportAndDispose() {
      if (!this.EmergencyWorkSituationLoading) {
        console.log(this.$refs.EmergencyWorkSituationRefs)
        let col = this.$refs.EmergencyWorkSituationRefs.columnRows
        let columns = [...col[0], ...col[1]]
        columns.map((item, index) => {
          if (item.title === '现场图片') {
            delete columns[index]
          } else {
            if (item.title === '处置前') {
              columns[index].title = '处置前图片'
              columns[index].type = 'image'
              columns[index].key = 'frontImage'
            }
            if (item.title === '处置后') {
              columns[index].title = '处置后图片'
              columns[index].type = 'image'
              columns[index].key = 'frontImage'
            }
          }
        })
        let fileData = []
        fileData = this.EmergencyWorkSituationList.map(item => {
          return {
            dept: item.dept,
            address: item.address,
            reportTime: item.reportTime,
            eventDescription: item.eventDescription,
            frontImage: item.frontImage === null ? '' : JSON.parse(JSON.parse(JSON.stringify(item.frontImage))).url,
            afterImage: item.afterImage === null ? '' : JSON.parse(JSON.parse(JSON.stringify(item.afterImage))).url,
            disposalOpinions: item.disposalOpinions,
            eventStatus: item.eventStatus
          }
        })
        const excelName = '截止' + this.$moment(new Date()).format('yyyy-MM-DD') + '应急事件具体工作情况'//文件名称
        table2excel(columns, fileData, excelName)    //生成Excel表格，自动下载
      } else {
        this.$Message.warning('数据加载中，请稍后再试！')
      }
    },
    clearData() {
      this.EmergencyWorkSituationForm.signTime = [this.$moment().subtract(1, 'weeks').format('YYYY-MM-DD'), this.$moment().format('YYYY-MM-DD')]
      this.getUsageSituationData()
    },
    getEmergencyWorkSituationList() {
      this.EmergencyWorkSituationLoading = true
      let requestData = {
        beginDate: new Date(this.EmergencyWorkSituationForm.signTime[0]),
        endDate: new Date(this.EmergencyWorkSituationForm.signTime[1])
      }
      this.$http.post(`api/getEmergencyEventConcreteWorkSituation`, requestData).then(res => {
        if (res.status === 200) {
          this.EmergencyWorkSituationList = res.data
          this.EmergencyWorkSituationLoading = false
        }
      })
    }
  }
}
</script>
